import src from "IMAGE";
export default { src, width: 190, height: 98, blurWidth: 0, blurHeight: 0};
